import Input from "../Shared/Input";
import { FormikTouched, useFormik } from "formik";
import Button from "../Shared/Button";
import { ButtonTypes } from "../../utils/consts";
import { motion } from "framer-motion";
import { useParams } from "react-router-dom";
import * as yup from "yup";
import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { AxiosError } from "axios";
import { verifyotp } from "../../api/Auth/verifyotp";
interface FormValues {
    code1: string;
    code2: string;
    code3: string;
    code4: string;
    code5: string;
    code6: string;
    email: string | undefined;
}

const validationSchema = yup.object({
    code1: yup.string().required("Code Required"),
    code2: yup.string().required("Code Required"),
    code3: yup.string().required("Code Required"),
    code4: yup.string().required("Code Required"),
    code5: yup.string().required("Code Required"),
    code6: yup.string().required("Code Required"),
    email: yup.string()
        .email("Invalid email address")
        .required("Email is required"),
});

const TokenForm = () => {
    const navigate = useNavigate();

    const { mutate, error } = useMutation({
        mutationFn: verifyotp,
        onSuccess: () => {
            navigate(`/reset-password/${email}`);
        },
        onError: () => {
            formik.setSubmitting(false);
        },
    });

    const { email } = useParams();

    const formik = useFormik<FormValues>({
        initialValues: {
            code1: "",
            code2: "",
            code3: "",
            code4: "",
            code5: "",
            code6: "",
            email,
        },
        validationSchema,
        onSubmit: (values) => {
            const fullCode = `${values.code1}${values.code2}${values.code3}${values.code4}${values.code5}${values.code6}`;
            const decodedEmail = decodeURIComponent(email as string);
            mutate({ email: decodedEmail, OTP: fullCode });
        },
    });
    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
        const { value } = e.target;
        const onlyNums = value.replace(/[^0-9]/g, '');

        const fieldName = `code${index + 1}` as keyof FormValues;
        formik.setFieldValue(fieldName, onlyNums);

    };
    return (
        <div className="my-auto">
      <div className="mb-8 md:text-start text-center">
                <h1 className="font-semibold sm:mb-2 mb-1 sm:text-[42px] text-28px">Enter OTP code</h1>
                <p className="font-medium sm:text-xl md:mx-0 mx-auto max-w-[500px]">Please check your message we sent an OTP code for you</p>
            </div>

            <motion.form
                onSubmit={formik.handleSubmit}
                className="flex flex-col w-full"
                initial={{ x: 60, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.5 }}
            >
                <div className="w-full h-full grid grid-cols-6 md:flex md:items-center gap-3">
                    {[1, 2, 3, 4, 5, 6].map((item, index) => {
                        const fieldName = `code${item}` as keyof FormikTouched<FormValues>;
                        return (
                            <Input
                                key={index}
                                type="tel"
                                name={`code${item}`}
                                inputStyles="sm:w-20 w-full sm:h-20 h-[52px] text-center font-bold sm:text-2xl"
                                placeholder="_"
                                className="text-center font-semibold"
                                value={formik.values[fieldName]}
                                onChange={(e) => handleInputChange(e, index)}
                                isCode
                                onBlur={formik.handleBlur}
                                error={
                                    formik.touched[fieldName] && formik.errors[fieldName]
                                        ? formik.errors[fieldName]
                                        : ""
                                }
                            />
                        );
                    })}
                </div>
                {error instanceof AxiosError && (
                    <span className="text-red-500 font-bold text-lg">
                        {error?.response?.data?.message || "An error occurred"}
                    </span>
                )}
                <div className="w-full h-full flex flex-col gap-5 items-center pt-8">
                    <Button
                        className="w-full md:mt-3 mt-2  md:h-16 h-[54px]"
                        type={ButtonTypes.SUBMIT}
                        variant="secondary"
                        disabled={formik.isSubmitting}
                    >
                        Submit
                    </Button>
                </div>
                <button className="flex justify-between text-primary sm:text-xl font-semibold pt-5">
                    <span>Resend OTP code</span>
                    <span>00:00</span>
                </button>
            </motion.form>
        </div>
    );
};

export default TokenForm;
